import { FieldContext } from "./chunk-57D4P5XD.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Field/Field.tsx
import { forwardRef, useMemo } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var FIELD_CLASSNAME_MAP = {};
var Field = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      id,
      name,
      label,
      required,
      requiredLabel,
      description,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["as", "id", "name", "label", "required", "requiredLabel", "description", "validation", "validationMessage", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const context = useMemo(() => ({
    id,
    name,
    label,
    required,
    requiredLabel,
    description,
    validation,
    validationMessage
  }), [id, name, label, required, requiredLabel, description, validation, validationMessage]);
  return /* @__PURE__ */jsx(FieldContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsx(Component, __spreadValues({
      ref,
      className: clsx("pd:field", className)
    }, rest))
  });
});
var Field_default = Field;
export { FIELD_CLASSNAME_MAP, Field_default };